import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map } from 'lodash-es'
import PropTypes from 'prop-types'

import {
  createUrl,
  getQueryParams,
} from '../../core/utils/services/queryParams'

import { TASK_RESOLVED_TYPES } from '../../tasks/constants'
import { DEFAULT_PAGE } from '../constants'

const TaskResolvedTypeFilter = ({ disabled }) => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { resolvedType } = getQueryParams(search)

  const handleChange = useCallback(
    resolvedType =>
      history.push(
        createUrl(pathname, search, {
          resolvedType,
          page: DEFAULT_PAGE,
        }),
      ),
    [history, pathname, search],
  )

  return (
    <Form.Item label="Task resolved type">
      <Select
        style={{ width: '100%' }}
        value={resolvedType}
        onChange={handleChange}
        disabled={disabled}
        allowClear
      >
        {map(TASK_RESOLVED_TYPES, ({ name, value }) => (
          <Select.Option key={value} value={value}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

TaskResolvedTypeFilter.propTypes = {
  disabled: PropTypes.bool,
}

TaskResolvedTypeFilter.defaultProps = {
  disabled: false,
}

export default TaskResolvedTypeFilter
